// src/api.js
{/*import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";

const api = axios.create({
  baseURL: API_BASE,
  timeout: 10000,
});

// attach access token automatically
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// optional response interceptor to handle 401 (see section 6 for full logic)
export default api;

*/}

// src/api.js
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "/api";

const api = axios.create({
  baseURL: API_BASE,
  timeout: 10000,
});

// attach access token automatically
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});



// optional response interceptor to handle 401 (see section 6 for full logic)
export default api;
